export const DOCUMENT_TAB = [
  { label: "Live", value: "live" },
  { label: "Deleted", value: "deleted" },
];

export const DOCUMENT_SOURCE_TYPES = {
  RECEIVED_FAX: "Received Fax",
  TRANSFERRED: "Transfer",
  UPLOAD: "Upload",
};

export const DOCUMENT_ENTITY_TYPES = {
  NAME: "NAME",
  PATIENT_NAME: "PATIENT_NAME",
  PATIENT_FIRSTNAME: "PATIENT_FIRST_NAME",
  PATIENT_LASTNAME: "PATIENT_LAST_NAME",
  DATE: "DATE",
  PATIENT_GENDER: "PATIENT_GENDER",
  PATIENT_DATE_OF_BIRTH: "PATIENT_DATE_OF_BIRTH",
  PRIORITY: "PRIORITY",
};

export const DOCUMENT_ENTITY_SOURCE = {
  COMPREHEND_MEDICAL: "COMPREHEND_MEDICAL",
};
